<template>
	<!-- 详细题型设置 中-->
	<div class="typesetting">
		<!--答题设置-->
		<div class="answer_set">
			<p class="limit" @click="questions = !questions">
				<span class="limit_ys"></span>
				<a name="answerSet">{{$t('SetUp.AnswerSet')}}</a>
				<i v-if="questions != true" class="el-icon-arrow-right limit_icon"></i>
				<i v-else class="el-icon-arrow-down limit_icon2"></i>
			</p>
			<div v-show="questions">
				<ul class="answer_set_ul answer_set_ul_top">
					<li class="button_line">
						<span>{{$t('SetUp.OnlyWeChatAnswerQuestions')}}</span>
						<el-switch v-model="resultBody.onlyWx" :active-value="1" :inactive-value="0" @change="switchonlyWx(resultBody.onlyWx)" />
					</li>
				</ul>
				<ul class="answer_set_ul answer_set_ul_top">
					<li class="button_line">
						<span>{{$t('SetUp.WeChatRestrictions')}}</span>
						<el-switch v-model="resultBody.wxLimit" :active-value="1" :inactive-value="0" @change="switchWxLimit(resultBody.wxLimit)" />
					</li>
					<li v-if="resultBody.wxLimit == 1" class="limit_num_box">
						<div class="limit_num">
							<div class="wx_limt">
								<el-select size="small" v-model="wxLimitFreq" :placeholder="$t('SetUp.PleaseSelect')" @change="wxLimit($event)">
									<el-option v-for="wxItem in wxLimitFreqOptions" :key="wxItem.value" :label="wxItem.label" :value="wxItem.value"></el-option>
								</el-select>
							</div>
							<div class="wx_limit_number">
								<span class="wx_limit_number_dt">{{$t('SetUp.Answer')}}</span>
								<el-input size="small" v-model="wxLimitNumber" :placeholder="$t('SetUp.PleaseEnterContent')" @blur="wxlimitInput"></el-input>
								<span class="wx_limit_number_dt">{{$t('SetUp.Times')}}</span>
							</div>
						</div>
					</li>
				</ul>
				<ul class="answer_set_ul">
					<li class="button_line">
						<span>{{$t('SetUp.ComputerOrPhoneRestrictions')}}</span>
						<el-switch
							:disabled="resultBody.onlyWx==1"
							v-model="resultBody.pcLimit"
							:active-value="1"
							:inactive-value="0"
							@change="switchPcLimit(resultBody.pcLimit)"
						/>
					</li>
					<li v-if="resultBody.pcLimit == 1" class="limit_num_box">
						<div class="limit_num">
							<div class="wx_limt">
								<el-select size="small" v-model="pcLimitFreq" :placeholder="$t('SetUp.PleaseSelect')" @change="wxPcLimit($event)">
									<el-option v-for="wxItem in wxLimitFreqOptions" :key="wxItem.value" :label="wxItem.label" :value="wxItem.value"></el-option>
								</el-select>
							</div>
							<div class="wx_limit_number">
								<span class="wx_limit_number_dt">{{$t('SetUp.Answer')}}</span>
								<el-input size="small" v-model="pcLimitNumber" :placeholder="$t('SetUp.PleaseEnterContent')" @blur="wxPclimitInput"></el-input>
								<span class="wx_limit_number_dt">{{$t('SetUp.Times')}}</span>
							</div>
						</div>
					</li>
				</ul>
				<ul class="answer_set_ul">
					<li class="button_line">
						<span>{{$t('SetUp.IPRestrictions')}}</span>
						<el-switch :disabled="resultBody.onlyWx==1" v-model="resultBody.ipLimit" :active-value="1" :inactive-value="0" @change="switchpLimit(resultBody.ipLimit)" />
					</li>
					<li v-if="resultBody.ipLimit == 1" class="limit_num_box">
						<div class="limit_num">
							<div class="wx_limt">
								<el-select size="small" v-model="ipLimitFreq" :placeholder="$t('SetUp.PleaseSelect')" @change="wxIpLimit($event)">
									<el-option v-for="wxItem in wxLimitFreqOptions" :key="wxItem.value" :label="wxItem.label" :value="wxItem.value"></el-option>
								</el-select>
							</div>
							<div class="wx_limit_number">
								<span class="wx_limit_number_dt">{{$t('SetUp.Answer')}}</span>
								<el-input size="small" v-model="ipLimitNumber" :placeholder="$t('SetUp.PleaseEnterContent')" @blur="wxIplimitInput"></el-input>
								<span class="wx_limit_number_dt">{{$t('SetUp.Times')}}</span>
							</div>
						</div>
					</li>
				</ul>
				<ul class="answer_set_ul">
					<li class="button_line">
						<span>{{$t('SetUp.ActivateAccessPassword')}}</span>
						<el-switch :disabled="resultBody.onlyWx==1" v-model="resultBody.startUpPassword" :active-value="1" :inactive-value="0" @change="switchStartUpPassword(resultBody.startUpPassword)" />
					</li>

					<li v-if="resultBody.startUpPassword == 1" class="limit_num_box">
						<div class="limit_num" style="padding: 10px 10px;">
							<el-input
								size="small"
								type="text"
								v-model="startPasswordNumber"
								:placeholder="$t('SetUp.EnterTheAccessPassword')"
								style="
					                    width: 300px;
					                  "
							/>
							<span style="color: #0080ff; margin-left: 15px; font-size: 13px;cursor: pointer;" @click="startPsSure(startPasswordNumber)">{{$t('main.ok')}}</span>
						</div>
					</li>
				</ul>
				<!-- <ul class="answer_set_ul">
					<li class="button_line" @click="limitPhone()">
						<span>限定手机号答题</span><i class="el-icon-arrow-right" style="color: #ccc"></i>
					</li>
				</ul> -->
				<ul class="answer_set_ul">
					<li class="button_line">
						<span>{{$t('SetUp.MailOnly')}}</span>
						<el-switch :disabled="resultBody.onlyWx==1" v-model="resultBody.onlyEmail" :active-value="1" :inactive-value="0" @change="switchOnlyEmail(resultBody.onlyEmail)" />
					</li>
				</ul>
				<ul class="answer_set_ul">
					<li class="button_line">
						<span>{{$t('SetUp.SetTime')}}</span>
						<el-switch  v-model="resultBody.setStartEndTime" :active-value="1" :inactive-value="0" @change="switchSetStartEndTime(resultBody.setStartEndTime)" />
					</li>
					<li v-if="resultBody.setStartEndTime == 1" class="limit_num_box">
						<div class="setTimer_num">
							<div class="timeSetting">
								<label>{{$t('SetUp.SetStartTime')}}</label>
								<div>
									<div class="block start">
										<el-date-picker
											:append-to-body="false"
											size="small"
											v-model="curWjInfo.startTime"
											value-format="yyyy-MM-dd HH:mm:ss"
											format="yyyy-MM-dd HH:mm:ss"
											type="datetime"
											:placeholder="$t('SetUp.NoRestrictions')"
											@change="kaiTimer()"
										></el-date-picker>
									</div>
								</div>
							</div>
							<div class="timeSetting">
								<label>{{$t('SetUp.SetEndTime')}}</label>
								<div>
									<div class="block start">
										<el-date-picker
											:append-to-body="false"
											size="small"
											v-model="curWjInfo.endTime"
											value-format="yyyy-MM-dd HH:mm:ss"
											format="yyyy-MM-dd HH:mm:ss"
											type="datetime"
											:placeholder="$t('SetUp.NoRestrictions')"
											@change="kaiTimer()"
										></el-date-picker>
									</div>
								</div>
							</div>
						</div>
						<div
							style="
                  display: none;
                  font-size: 12px;
                  color: red;
                  margin-left: 47px;
                "
							id="timeId"
						>
							{{$t('SetUp.EndTimeGreaterThanStartTime')}}
						</div>
					</li>
				</ul>
				<!--是否允许断点续答后期完善-->
				<!-- <ul style="width:700px;background:#fff">
                              <li class="button_line" style="border:none"><span>是否允许断点续答</span><el-switch  v-model="resultBody.breakpointAnswer" :active-value="1" :inactive-value='0' @change="switchBreakpointAnswer(resultBody.breakpointAnswer)"/> </li>
                              <li style="margin-left:20px;font-family: MicrosoftYaHei;font-size: 12px;padding-bottom:19px">填写者在填写过程中，可以关闭页面。下次打开可以继续上一次的作答进度继续答题</li>
                          </ul>-->
			</div>
		</div>
		<!-- 微信设置 -->
		<!--微信设置后期完善-->
		<!--<div class="answer_set">
                      <div style="padding-top:25px">
                          <p class="limit"><span></span> <a name="wxSet">微信设置</a></p>
                          <ul style="width:700px;background:#fff;margin-top:28px">
                              <li class="button_line"><span>只能通过微信回答</span><el-switch  v-model="resultBody.onlyWx" :active-value="1" :inactive-value='0' @change="switchOnlyWx(resultBody.onlyWx)"/> </li>
                          </ul>
                          <ul style="width:700px;background:#fff">
                              <li class="button_line" style="border:none"><span>记录微信用户个人信息</span><el-switch  v-model="resultBody.recordWxUser" :active-value="1" :inactive-value='0' @change="switchRecordWxUser(resultBody.recordWxUser)"/> </li>
                              <li style="margin-left:20px;font-family:MicrosoftYaHei;font-size:12px;padding-bottom:19px;">回答前需要答题者授权登录，提供微信昵称、性别、城市信息</li>
                              <li v-if="resultBody.recordWxUser == 1" class="limit_num_box"> 
                                  <div class="collection_method">
                                      <div style="margin-top:24px">
                                          <span style="font-size:14px;color:#333">收集方式 :</span>
                                          <div v-for="(items,indexs) in coll" :key="indexs">
                                              <el-radio v-model="radios" :label="items.value" style="color:#333;" @change="Singlechoice(items.value)">{{items.label}}</el-radio>
                                          </div>
                                      </div>
                                      <div style="margin-top:10px;margin-bottom:18px">
                                          <span style='font-size:14px;color:#333'>授权方式 :</span>
                                          <div v-for="(items,indexs) in Auth" :key="indexs">
                                              <el-radio v-model="radios1" :label="items.value" style="color:#333;" @change="AuthSinglechoice(items.value)">{{items.label}}</el-radio>
                                          </div>
                                      </div>
                                  </div>
                              </li>
                          </ul>
                          <ul style="width:700px;background:#fff">
                              <li class="button_line" @click="customWechatSharing()"><span>自定义微信分享图标 </span><i class="el-icon-arrow-right" style="color:#ccc"></i></li>
                          </ul>
                          <ul style="width:700px;background:#fff">
                              <li class="button_line" style="border:none"><span>禁止微信右上角分享</span><el-switch  v-model="resultBody.prohibitWXShare" :active-value="1" :inactive-value='0' @change="switchProhibitWXShare(resultBody.prohibitWXShare)"/> </li>
                          </ul>
                      </div>
                  </div>-->

		<!-- 提醒设置 -->
		<!-- <div class="answer_set">
			<p class="limit" @click="remind = !remind">
				<span class="limit_ys"></span> <a name="remindSet">提醒设置</a>
				<i v-if="remind != true" class="el-icon-arrow-right limit_icon"></i>
				<i v-else class="el-icon-arrow-down limit_icon2"></i>
			</p>
			<div v-show="remind">
				<ul class="answer_set_ul answer_set_ul_top">
					<li class="button_line">
						<span>有新数据时，通过微信提醒我 </span>
						<el-switch v-model="resultBody.newMsgtoWX" :active-value="1" :inactive-value="0"
							@change="switchNewMsgtoWX(resultBody.newMsgtoWX)" />
					</li>
					<li v-if="resultBody.newMsgtoWX == 1" class="limit_num_box">
						<div class="limit_num">已开启,请关注微信通知</div>
					</li>
				</ul>
				<ul class="answer_set_ul">
					<li class="button_line" style="border: none">
						<span>有新数据时，通过邮件提醒我 </span>
						<el-switch v-model="resultBody.newMsgtoEmail" :active-value="1" :inactive-value="0"
							@change="switchNewMsgtoEmail(resultBody.newMsgtoEmail)" />
					</li>
					<li v-if="resultBody.newMsgtoEmail == 1" class="limit_num_box">
						<div class="limit_num">已开启请关注邮件通知</div>
					</li>
				</ul>
			</div>
		</div> -->

		<!-- 质量设置 -->
		<div class="answer_set">
			<p class="limit" @click="TheQuality = !TheQuality">
				<span class="limit_ys"></span>
				<a name="qualitySet">{{$t('SetUp.QualitySettings')}}</a>

				<i v-if="TheQuality != true" class="el-icon-arrow-right limit_icon"></i>
				<i v-else class="el-icon-arrow-down limit_icon2"></i>
			</p>
			<div v-show="TheQuality">
				<ul class="answer_set_ul answer_set_ul_top">
					<li class="button_line">
						<span>{{$t('SetUp.SetDataUpperLimit')}}</span>
						<el-switch v-model="resultBody.setAnswerLimit" :active-value="1" :inactive-value="0" @change="switchIfAnswerDataLimit" />
					</li>

					<li v-if="resultBody.setAnswerLimit == 1" class="limit_num_box">
						<div class="limit_num" style="font-size: 13px;padding: 10px 10px;">
							<span>{{$t('SetUp.Collect')}}</span>
							<el-input style="width: 200px;" size="small" v-model="resultBody.setAnswerLimitNumber"></el-input>
							<span>{{$t('SetUp.EndOfData')}}</span>
							<span style="color: #0080ff; margin-left: 18px ;cursor: pointer;" @click="answerLimit(resultBody.setAnswerLimitNumber)">{{$t('main.ok')}}</span>
						</div>
					</li>
				</ul>
				<ul class="answer_set_ul">
					<li class="button_line">
						<span>{{$t('SetUp.ControlPageFillingTime')}}</span>
						<el-switch v-model="resultBody.ifPageAnswerTime" :active-value="1" :inactive-value="0" @change="switchPageAnswerTime(resultBody.ifPageAnswerTime)" />
					</li>
					<li v-if="resultBody.ifPageAnswerTime == 1" class="limit_num_box">
						<div class="" style="font-size: 13px;padding: 10px 10px;">
							<span>{{$t('SetUp.Limitation')}}</span>
							<el-input style="width: 200px;" size="small" v-model="resultBody.pageAnswerTime"></el-input>
							<span class="limit_num_span2">{{$t('SetUp.TimedOutAutomaticSubmission')}}</span>
							<span style="color: #0080ff; margin-left: 18px;cursor: pointer;" @click="answerNumbers(resultBody.pageAnswerTime)">{{$t('main.ok')}}</span>
						</div>
					</li>
				</ul>
				<ul class="answer_set_ul">
					<li class="button_line" @click="setQuota()">
						<span>{{$t('SetUp.SetQuotas')}}</span>
						<i class="el-icon-arrow-right" style="color: #ccc"></i>
					</li>
				</ul>
				<!-- <ul class="answer_set_ul">
					<li class="button_line" style="border: none">
						<span>使用规则自动筛选无效答卷</span><i class="el-icon-arrow-right" style="color: #ccc"></i>
					</li>
				</ul> -->
			</div>
		</div>

		<!-- 公开设置 -->
		<div class="answer_set">
			<p class="limit" @click="Public = !Public">
				<span class="limit_ys"></span>
				<a name="inquireSet">{{$t('SetUp.PublicSettings')}}</a>
				<i v-if="Public != true" class="el-icon-arrow-right limit_icon"></i>
				<i v-else class="el-icon-arrow-down limit_icon2"></i>
			</p>
			<div v-show="Public">
				<!-- <ul class="answer_set_ul answer_set_ul_top">
					<li class="button_line">
						<span>是否允许受访人查看统计</span>
						<el-switch v-model="resultBody.ifAllowStatistics" :active-value="1" :inactive-value="0" @change="switchIfAllowStatistics(resultBody.ifAllowStatistics)" />
					</li>
				</ul> -->
				<ul class="answer_set_ul">
					<li class="button_line" style="border: none">
						<span>{{$t('SetUp.ShareButton')}}</span>
						<el-switch v-model="resultBody.ifDisplayShare" :active-value="1" :inactive-value="0" @change="switchIfDisplayShare(resultBody.ifDisplayShare)" />
					</li>
				</ul>
				<ul class="answer_set_ul">
					<li class="button_line">
						<span>{{$t('SetUp.AnswerSquare')}}</span>
						<el-switch v-model="curWjInfo.ifanswerPlaza" :active-value="1" :inactive-value="0" @change="setAnswerPlaza(curWjInfo.ifanswerPlaza)" />
					</li>
				</ul>
			</div>
		</div>

		<!--样本设置-->
		<!-- <div class="answer_set">
        <p class="limit" @click="sampleSet = !sampleSet">
          <span class="limit_ys"></span><a name="sampleSet">样本设置</a>
      <i v-if="sampleSet != true" class="el-icon-arrow-right limit_icon"></i>
      <i v-else class="el-icon-arrow-down limit_icon2"></i>
        </p>
        <div v-show="sampleSet">
          <router-link
            to="SampleManagement"
            tag="ul"
            class="answer_set_ul answer_set_ul_top"
          >
            <li class="button_line">
              <span>样本管理</span>
              <i class="el-icon-arrow-right" style="color: #ccc"></i>
            </li>
          </router-link>
          <router-link to="SampleAssignment" tag="ul" class="answer_set_ul">
            <li class="button_line">
              <span>样本指派</span>
              <i class="el-icon-arrow-right" style="color: #ccc"></i>
            </li>
          </router-link>
        </div>
      </div> -->

		<!-- 奖品与红包 -->
		<!-- <div class="answer_set">
        <p class="limit" @click="ThePrize = !ThePrize">
          <span class="limit_ys"></span><a name="prizeSet">奖品与红包</a>
      <i v-if="ThePrize != true" class="el-icon-arrow-right limit_icon"></i>
      <i v-else class="el-icon-arrow-down limit_icon2"></i>
        </p>
        <div v-show="ThePrize">
      <ul class="answer_set_ul answer_set_ul_top">
        <li class="button_line">
          <span @click="redpacket">微信红包</span>
          <i class="el-icon-arrow-right" style="color: #ccc"></i>
        </li>
      </ul>
      
          <ul class="answer_set_ul">
            <li class="button_line" style="border: none">
              <span>自定义抽奖</span
              ><i class="el-icon-arrow-right" style="color: #ccc"></i>
            </li>
          </ul>
        </div>
      </div> -->

		<!-- 其他设置 -->
		<div class="answer_set">
			<p class="limit" @click="other = !other">
				<span class="limit_ys"></span>
				<a name="elseSet">{{$t('SetUp.OtherSettings')}}</a>
				<i v-if="other != true" class="el-icon-arrow-right limit_icon"></i>
				<i v-else class="el-icon-arrow-down limit_icon2"></i>
			</p>
			<div v-show="other">
				<ul class="answer_set_ul answer_set_ul_top">
					<li class="button_line">
						<span>{{$t('SetUp.CustomJump')}}</span>
						<el-switch v-model="resultBody.ifCustomJump" :active-value="1" :inactive-value="0" @change="switchCustomJump(resultBody.customJump)" />
					</li>
					<li v-if="resultBody.ifCustomJump == 1" class="limit_num_box">
						<div class="collection_method" v-for="(items, indexs) in cust" :key="indexs">
							<el-radio v-model="radios2" :label="items.value" style="color: #333; height: 36px; line-height: 36px" @change="Customjump(items.value)">
								{{ items.label }}
								<el-tooltip v-if="items.value == 1" class="item" effect="dark" placement="top">
									<div slot="content">
										{{$t('SetUp.SettableVariables')}} http://www.baidu.com?id=[Id]
										<br />
										[surveyId] : {{$t('SetUp.QuestionnaireIdentification')}}
										<br />
										[userId] ：{{$t('SetUp.UserId')}}
										<br />
										[thronlyid]：{{$t('SetUp.ThirdParty')}}
										<br />
										[Id] ：{{$t('SetUp.UniqueId')}}
									</div>
									<span>?</span>
								</el-tooltip>
							</el-radio>
							<el-form :model="custForm" ref="custForm" :rules="custRules" class="demo-dynamic">
								<!-- <el-form-item v-if="!skipUrl && indexs == 0" prop="input">
									<el-input :maxlength="255" v-model="custForm.input" placeholder="请输入内容" @blur="jump(items.value, 'custForm')"></el-input>
								</el-form-item> -->
								<el-form-item prop="input2">
									<el-input size="small" v-model="custForm.input2" :placeholder="$t('SetUp.PleaseEnterContent')" @blur="jump(items.value)"></el-input>
								</el-form-item>
							</el-form>
						</div>
					</li>
				</ul>
				<ul class="answer_set_ul">
					<!-- <li class="button_line" style="border: none">
						<span>允许搜索引擎检索项目内容</span>
						<el-switch v-model="resultBody.shareSeoIndex" :active-value="1" :inactive-value="0" @change="switchShareSeoIndex(resultBody.shareSeoIndex)" />
					</li>
					<li
						style="
						margin-left: 20px;
						font-family: MicrosoftYaHei;
						font-size: 12px;
						padding-bottom: 19px;
					"
					>
						关闭此功能时如搜索引擎已经检索，需自行投诉快照进行删除
					</li> -->
					<li class="button_line" style="border: none">
						<span>{{$t('SetUp.Staging')}}</span>
						<el-switch v-model="resultBody.isStaging" :active-value="1" :inactive-value="0" @change="switchStaging(resultBody.isStaging)" />
					</li>
				</ul>
				<ul class="answer_set_ul">
					<li class="button_line" @click="openSampleParameterSetting">
						<span>{{$t('SetUp.ThirdPartyTitle')}}</span>
						<i class="el-icon-arrow-right" style="color: #ccc"></i>
					</li>
				</ul>
				<ul class="answer_set_ul answer_set_ul_top">
					<li class="button_line">
						<span>{{$t('SetUp.SatisfactionScore')}}</span>
						<el-switch
							v-model="resultBody.isEnableSibleScoringFormula"
							@change="switchIsEnableSibleScoringFormula(resultBody.isEnableSibleScoringFormula)"
							:active-value="1"
							:inactive-value="0"
						/>
					</li>

					<li v-if="resultBody.isEnableSibleScoringFormula == 1" class="limit_num_box">
						<div class="limit_num" style="padding: 10px 10px;">
							<el-input
								size="small"
								type="text"
								v-model="resultBody.sibleScoringFormula"
								:placeholder="`sible${$t('SetUp.TotalScoreFormula')}`"
								style="
					                    width: 300px;
					                  "
							/>
							<span style="color: #0080ff; margin-left: 15px; font-size: 13px;cursor: pointer;" @click="sibleScoringFormulaOk(startPasswordNumber)">{{$t('main.ok')}}</span>
						</div>
					</li>
				</ul>
				<ul class="answer_set_ul answer_set_ul_top">
					<li class="button_line">
						<span>版权语设置</span>
						<el-switch
							v-model="resultBody.copyrightConfig"
							@change="copyrightSetSwitch(0)"
							:active-value="1"
							:inactive-value="0"
						/>
					</li>

					<li v-if="resultBody.copyrightConfig == 1" class="limit_num_box">
						<div class="limit_num" style="padding: 10px 10px;">
							<el-input
								size="small"
								type="text"
								v-model="resultBody.copyrightConfigContent"
								placeholder="版权语设置"
								@blur="copyrightSetSwitch(1)"
							/>
						</div>
					</li>
				</ul>
				
				<ul class="answer_set_ul">
					<li class="button_line" style="cursor: pointer;" @click="randomSet">
						<span>{{$t('SetUp.RandomSettings')}}</span>
						<i class="el-icon-arrow-right" style="color: #ccc"></i>
					</li>
				</ul>
				
				<!-- <ul class="answer_set_ul">
            <li class="button_line" style="border: none">
              <span>隐藏“神采”logo</span
              ><el-switch
                v-model="resultBody.hideLogo"
                :active-value="1"
                :inactive-value="0"
                @change="switchHideLogo(resultBody.hideLogo)"
              />
            </li>
          </ul> -->
			</div>
		</div>
		<!-- siebel对接设置 -->
		<div class="answer_set">
			<p class="limit" @click="siebel = !siebel">
				<span class="limit_ys"></span>
				<a name="siebelSet">siebel{{$t('SetUp.DockingSettings')}}</a>
				<i v-if="siebel != true" class="el-icon-arrow-right limit_icon"></i>
				<i v-else class="el-icon-arrow-down limit_icon2"></i>
			</p>
			<div v-show="siebel">
				<ul class="answer_set_ul answer_set_ul_top">
					<li class="button_line">
						<span>{{$t('SetUp.IsTheQuestionnaireValid')}}</span>
						<el-switch v-model="resultBody.isEnableSible" @change="switchIsEnableSible(resultBody.isEnableSible)" :active-value="1" :inactive-value="0" />
					</li>

					<li v-if="resultBody.isEnableSible == 1" class="limit_num_box">
						<div class="limit_num" style="padding: 10px 10px;">
							<el-input
								size="small"
								type="text"
								v-model="resultBody.validDay"
								:placeholder="$t('SetUp.SetEffectiveTime')"
								style="
					                    width: 300px;
					                  "
							/>
							<span style="color: #0080ff; margin-left: 15px; font-size: 13px;cursor: pointer;" @click="setEffectiveTime">{{$t('main.ok')}}</span>
						</div>
					</li>
				</ul>
				<ul class="answer_set_ul">
					<li class="button_line" @click="openSampleParameterSetting">
						<span>{{$t('SetUp.SynchronizeSamples')}}</span>
						<i class="el-icon-arrow-right" style="color: #ccc"></i>
					</li>
				</ul>
				<ul class="answer_set_ul">
					<li class="button_line" @click="openRule">
						<span>{{$t('SetUp.RuleSettings')}}</span>
						<i class="el-icon-arrow-right" style="color: #ccc"></i>
					</li>
				</ul>

			</div>
		</div>
		<!-- 随机设置 -->
		<RandomSet ref="RandomSet" :paperjson="paperjson" :randomJson="curWjInfo.randomJson" :id="wid"></RandomSet>

	  
	  		<el-dialog :title="$t('SetUp.SampleParameters')" :visible.sync="sampleParameterSettingVisible" width="1000px" :close-on-click-modal="false">
				<div>
					<!-- <el-button @click="openAddsampleParameterSetting">添加</el-button> -->
					<!-- 福田 -->
					<el-button size="small" @click="shencaiOpenAddsampleParameterSetting">{{$t('SetUp.Add')}}</el-button>
					<!-- 神采 -->
					<el-table v-loading="dataLoading" :data="sampleParameterData" style="width: 100%">
						<el-table-column prop="chfieldName" :label="$t('SetUp.FieldName')"></el-table-column>
						<el-table-column prop="enfieldName" :label="$t('SetUp.EnglishName')"></el-table-column>
						<el-table-column width="200"  :label="$t('main.operate')">
							<template slot-scope="scope">
								<el-popconfirm :title="$t('SetUp.DeleteIt')" @confirm="delSampleParameterClick(scope.row.id)">
									<el-button slot="reference" type="text" size="small">{{$t('main.delete')}}</el-button>
								</el-popconfirm>
							</template>
						</el-table-column>
					</el-table>
					<div class="block">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="pagination.currentPage"
							:page-sizes="[1, 10, 50, 100, 200, 300, 400]"
							:page-size="pagination.pageSize"
							layout="total, sizes, prev, pager, next, jumper"
							:total="pagination.total"
						></el-pagination>
					</div>
				</div>
				<span slot="footer" class="dialog-footer"><el-button size="small" type="primary" @click="sampleParameterSettingVisible = false">{{$t('SetUp.Close')}}</el-button></span>
			</el-dialog>

			<el-dialog :title="$t('SetUp.Add')" :visible.sync="addsampleParameterSettingVisible" width="500px" :close-on-click-modal="false" append-to-body>
				<el-table :data="addSampleParameterData" style="width: 100%">
					<el-table-column prop="chfieldName" :label="$t('SetUp.FieldName')"></el-table-column>
					<el-table-column prop="enfieldName" :label="$t('SetUp.EnglishName')"></el-table-column>
					<el-table-column width="200" :label="$t('main.operate')">
						<template slot-scope="scope">
							<el-button @click="addSampleParameterClick(scope.row.id)" type="text" size="small">{{$t('SetUp.Add')}}</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="block">
					<el-pagination
						@size-change="addhandleSizeChange"
						@current-change="addhandleCurrentChange"
						:current-page="pagination.currentPage"
						:page-sizes="[1, 10, 50, 100, 200, 300, 400]"
						:page-size="addpagination.pageSize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="addpagination.total"
					></el-pagination>
				</div>
				<span slot="footer" class="dialog-footer"><el-button type="primary" @click="addsampleParameterSettingVisible = false">{{$t('SetUp.Close')}}</el-button></span>
			</el-dialog>
			<!-- 神采问卷添加字段 -->
			<el-dialog :title="$t('SetUp.Add')" :visible.sync="shencaiAddsampleParameterSettingVisible" width="800px" :close-on-click-modal="false" append-to-body>
				<div>
					<el-input size="small" type="text" :placeholder="$t('SetUp.PleaseEnterAFieldName')" v-model="shencaiChfieldName" maxlength="20" show-word-limit></el-input>
					<el-input size="small" style="margin-top: 10px;" type="text" :placeholder="$t('SetUp.PleaseEnterAnEnglishName')" v-model="shencaiEnfieldName" maxlength="20" show-word-limit></el-input>
				</div>
				<span slot="footer" class="dialog-footer"><el-button :loading="saveSiebleFieldLoading"  size="small" type="primary" @click="shencaiAddsampleParameterSettingVisibleOk">{{$t('main.ok')}}</el-button></span>
			</el-dialog>

			<el-dialog :title="$t('SetUp.RuleSettings')" :visible.sync="RuleVisible" width="1000px" :close-on-click-modal="false">
				<el-button size="small" @click="oepnAddRule">{{$t('SetUp.Add')}}</el-button>
				<el-button size="small" style="float:right" @click="payAReturnVisit('hfqd')">{{$t('SetUp.ReturnVisitChannels')}}</el-button>
				<el-button size="small" style="float:right" @click="payAReturnVisit('hflx')">{{$t('SetUp.FollowUpType')}}</el-button>
				<el-table :data="RuleData" style="width: 100%">
					<el-table-column prop="hflx" :label="$t('SetUp.FollowUpType')"></el-table-column>
					<el-table-column prop="hfqd" :label="$t('SetUp.ReturnVisitChannels')"></el-table-column>
					<el-table-column :label="$t('SetUp.ValidOrNot')">
						<template slot-scope="scope">
							<span v-if="scope.row.isValid == 1">{{$t('SetUp.Yes')}}</span>
							<span v-else>{{$t('SetUp.No')}}</span>
						</template>
					</el-table-column>

					<el-table-column width="200"  :label="$t('main.operate')">
						<template slot-scope="scope">
							<el-button @click="editRule(scope.row)" type="text" size="small">{{$t('main.edit')}}</el-button>

							<el-popconfirm :title="$t('SetUp.DeleteIt')" @confirm="delRule(scope.row.id)">
								<el-button slot="reference" type="text" size="small">{{$t('main.delete')}}</el-button>
							</el-popconfirm>
						</template>
					</el-table-column>
				</el-table>
				<div class="block">
					<el-pagination
						@size-change="RulehandleSizeChange"
						@current-change="RulehandleCurrentChange"
						:current-page="Rulepagination.currentPage"
						:page-sizes="[1, 10, 50, 100, 200, 300, 400]"
						:page-size="Rulepagination.pageSize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="Rulepagination.total"
					></el-pagination>
				</div>
				<span slot="footer" class="dialog-footer"><el-button size="small" type="primary" @click="RuleVisible = false">{{$t('SetUp.Close')}}</el-button></span>
			</el-dialog>

			<el-dialog :title="$t('SetUp.AddRuleSettings')" :visible.sync="addRuleVisible" append-to-body width="800px" :close-on-click-modal="false">
				<el-form :model="addRuleForm">
					<el-form-item :label="$t('SetUp.RuleType')" :label-width="formLabelWidth">
						<el-select size="small" v-model="addRuleForm.hflx" :placeholder="$t('SetUp.SelectARuleType')">
							<el-option v-for="item in hflxList" :key="item.id" :label="item.value" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('SetUp.RuleChannel')" :label-width="formLabelWidth">
						<el-select size="small" v-model="addRuleForm.hfqd" :placeholder="$t('SetUp.SelectARuleChannel')">
							<el-option v-for="item in hfqdList" :key="item.id" :label="item.value" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('SetUp.ValidOrNot')" :label-width="formLabelWidth">
						<el-radio-group v-model="addRuleForm.isValid">
							<el-radio :label="1">{{$t('SetUp.Yes')}}</el-radio>
							<el-radio :label="0">{{$t('SetUp.No')}}</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer"><el-button size="small" type="primary" @click="addRuleOk">{{$t('main.ok')}}</el-button></span>
			</el-dialog>

			<el-dialog :title="$t('SetUp.EditQuestionnaireRuleSettings')" :visible.sync="editRuleVisible" append-to-body width="800px" :close-on-click-modal="false">
				<el-form :model="addRuleForm">
					<el-form-item :label="$t('SetUp.RuleType')" :label-width="formLabelWidth">
						<el-select size="small" v-model="addRuleForm.hflx" :placeholder="$t('SetUp.SelectARuleType')">
							<el-option v-for="item in hflxList" :key="item.id" :label="item.value" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('SetUp.RuleChannel')" :label-width="formLabelWidth">
						<el-select size="small" v-model="addRuleForm.hfqd" :placeholder="$t('SetUp.SelectARuleChannel')">
							<el-option v-for="item in hfqdList" :key="item.id" :label="item.value" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('SetUp.ValidOrNot')" :label-width="formLabelWidth">
						<el-radio-group v-model="addRuleForm.isValid">
							<el-radio :label="1">{{$t('SetUp.Yes')}}</el-radio>
							<el-radio :label="0">{{$t('SetUp.No')}}</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer"><el-button size="small" type="primary" @click="editRuleOk">{{$t('main.ok')}}</el-button></span>
			</el-dialog>

			<el-dialog :title="enumByTitle" :visible.sync="enumByVisible" width="900px" :close-on-click-modal="false">
				<el-button size="small" @click="openAddEnumBy">{{$t('SetUp.Add')}}</el-button>
				<el-table :data="enumByData" style="width: 100%">
					<el-table-column prop="value" :label="$t('SetUp.NameOfFollowUpVisit')"></el-table-column>
					<el-table-column :label="$t('SetUp.FollowUpType')">
						<template slot-scope="scope">
							<span v-if="scope.row.type == 'hflx'">{{$t('SetUp.FollowUpType')}}</span>
							<span v-else>{{$t('SetUp.ReturnVisitChannels')}}</span>
						</template>
					</el-table-column>
					<el-table-column  width="200" prop="type" :label="$t('main.operate')">
						<template slot-scope="scope">
							<el-button @click="openEditEnumBy(scope.row)" type="text" size="small">{{$t('main.edit')}}</el-button>
							<el-popconfirm :title="$t('SetUp.DeleteIt')" @confirm="delEnumBy(scope.row.id)">
								<el-button slot="reference" type="text" size="small">{{$t('main.delete')}}</el-button>
							</el-popconfirm>
						</template>
					</el-table-column>
				</el-table>
				<div class="block">
					<el-pagination
						@size-change="enumByhandleSizeChange"
						@current-change="enumByhandleCurrentChange"
						:current-page="enumBypagination.currentPage"
						:page-sizes="[1, 10, 50, 100, 200, 300, 400]"
						:page-size="enumBypagination.pageSize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="enumBypagination.total"
					></el-pagination>
				</div>
				<span slot="footer" class="dialog-footer"><el-button type="primary" size="small" @click="enumByVisible = false">{{$t('SetUp.Close')}}</el-button></span>
			</el-dialog>

			<el-dialog :title="$t('SetUp.AddRuleSettings')" :visible.sync="addEnumByVisible" append-to-body width="800px" :close-on-click-modal="false">
				<el-form :model="addEnumByForm">
					<el-form-item :label="$t('SetUp.RuleName')" :label-width="formLabelWidth"><el-input size="small" v-model="addEnumByForm.value" autocomplete="off"></el-input></el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer"><el-button size="small" type="primary" @click="addEnumByOk">{{$t('main.ok')}}</el-button></span>
			</el-dialog>

			<el-dialog :title="$t('SetUp.ModifyQuestionnaireRules')" :visible.sync="editEnumByVisible" append-to-body width="800px" :close-on-click-modal="false">
				<el-form :model="addEnumByForm">
					<el-form-item :label="$t('SetUp.RuleName')" :label-width="formLabelWidth"><el-input size="small" v-model="addEnumByForm.value" autocomplete="off"></el-input></el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer"><el-button size="small" type="primary" @click="editEnumByOk">{{$t('main.ok')}}</el-button></span>
			</el-dialog>

			<!-- 是否启用问卷总分公式设置 -->
			<el-dialog :title="`sible${$t('SetUp.TotalScoreFormula')}`" :visible.sync="sibleScoringFormulaVisible" width="800px" :close-on-click-modal="false">
				<el-input type="textarea" :rows="2" :placeholder="$t('SetUp.PleaseEnterContent')" v-model="resultBody.sibleScoringFormula"></el-input>
				<span slot="footer" class="dialog-footer">
					<el-button size="small" @click="sibleScoringFormulaVisible = false">{{$t('main.cancel2')}}</el-button>
					<el-button size="small" type="primary" @click="sibleScoringFormulaOk">{{$t('main.ok2')}}</el-button>
				</span>
			</el-dialog>
	</div>
</template>

<script>
import RandomSet from './questionnaireSetting/RandomSet'
export default {
	components:{
		RandomSet
	},
	data() {
		return {
			wid: '',
			siebel:true,
			shencaiChfieldName: '',
			shencaiEnfieldName: '',
			shencaiAddsampleParameterSettingVisible: false,
			editRuleVisible: false,
			hflxList: [],
			hfqdList: [],
			addEnumByForm: {},
			editEnumByVisible: false,
			addEnumByVisible: false,
			enumByType: '',
			enumByVisible: false,
			enumByData: [],
			enumBypagination: {
				currentPage: 1,
				pageSize: 10,
				total: 0
			},
			enumByTitle: this.$t('SetUp.FollowUpType'),
			formLabelWidth: '120px',
			addRuleForm: {},
			addRuleVisible: false,
			RuleData: [],
			RuleVisible: false,
			Rulepagination: {
				currentPage: 1,
				pageSize: 10,
				total: 0
			},
			addSampleParameterData: [],
			addpagination: {
				currentPage: 1,
				pageSize: 10,
				total: 0
			},
			addsampleParameterSettingVisible: false,
			pagination: {
				currentPage: 1,
				pageSize: 10,
				total: 0
			},
			sampleParameterData: [],
			dataLoading: false,
			sampleParameterSettingVisible: false,
			sibleScoringFormulaVisible: false,
			sampleSet: true,
			remind: true,
			questions: true,
			TheQuality: true,
			Public: true,
			ThePrize: true,
			other: true,
			discussPersonally: true,
			TelephoneInterviews: true,
			btnUpload: false,
			hiden: false,
			szTypeList: [
				{
					id: 1,
					title: this.$t('SetUp.AnswerSet'),
					icon: '',
					icon1: '',
					href: 'anseweSet',
					name: 'anseweSet'
				},
				{
					id: 2,
					title: this.$t('SetUp.WeChatSettings'),
					icon: '',
					icon1: '',
					href: 'wxSet',
					name: 'wxSet'
				},
				// {
				// 	id: 3,
				// 	title: "提醒设置",
				// 	icon: "",
				// 	icon1: "",
				// 	href: "remindSet",
				// 	name: "remindSet"
				// },
				{
					id: 4,
					title: this.$t('SetUp.QualitySettings'),
					icon: '',
					icon1: '',
					href: 'qualitySet',
					name: 'qualitySet'
				},
				{
					id: 5,
					title: this.$t('SetUp.QuerySettings'),
					icon: '',
					icon1: '',
					href: 'inquireSet',
					name: 'inquireSet'
				},
				{
					id: 6,
					title: this.$t('SetUp.SampleSettings'),
					icon: '',
					icon1: '',
					href: 'sampleSet',
					name: 'sampleSet'
				},
				{
					id: 7,
					title: this.$t('SetUp.PrizesAndRedEnvelopes'),
					icon: '',
					icon1: '',
					href: 'prizeSet',
					name: 'prizeSet'
				},
				{
					id: 8,
					title: this.$t('SetUp.OtherSettings'),
					icon: '',
					icon1: '',
					href: 'elseSet',
					name: 'elseSet'
				},
			],
			curSzType: {},
			height: 0,
			resultBody: {},
			curWjInfo: {},
			ipLimitFreq: '', //每个IP答题次数状态
			wjId: '',
			wxLimitNumber: '', // 每个微信答题次数限制
			wxLimitFreqOptions: [
				{
					value: '0',
					label: this.$t('SetUp.CanOnly')
				},
				{
					value: '1',
					label: this.$t('SetUp.EveryHour')
				},
				{
					value: '2',
					label: this.$t('SetUp.EveryDay')
				},
				{
					value: '3',
					label: this.$t('SetUp.Weekly')
				},
				{
					value: '4',
					label: this.$t('SetUp.Monthly')
				}
			],
			pcLimitNumber: '', //每台电脑或手机答题次数限制
			ipLimitNumber: '', // 每个IP答题次数限制
			startPasswordNumber: '', //启动访问密码
			pcLimitFreq: '', //每台电脑或手机答题状态
			wxLimitFreq: '',
			startTimerState: false, // 设置开始时间状态
			answerlimit: '',
			endTimerState: false,
			specifiedTimerState: false,
			startSelTimer: '',
			endSelTimer: '',
			ifanswerPlaza: 0,
			// coll: [
			// 	{
			// 		label: '强制用户必须授权才可回答',
			// 		value: 0
			// 	},
			// 	{
			// 		label: '非强制收集，提示用户授权，用户可跳过不提供信息',
			// 		value: 1
			// 	}
			// ],
			radios: '',
			// Auth: [
			// 	{
			// 		label: '我没有微信服务号，通过神采问卷官方微信服务号来收集',
			// 		value: 0
			// 	},
			// 	{
			// 		label: '我有微信服务号，希望通过自己的服务号来收集。用户将看到服务号授权页面',
			// 		value: 1
			// 	}
			// ],
			radios1: '',
			cust: [
				// {
				// 	label: '显示感谢信息',
				// 	value: 0
				// },
				{
					label: this.$t('SetUp.JumpToTheSpecifiedPage'),
					value: 1
				}
			],
			radios2: 1,
			custForm: {
				input: this.$t('SetUp.Thanking'),
				input2: ''
			},
			custRules: {
				input: [
					{
						required: false
					}
				],
				input2: [
					{
						required: true,
						message: this.$t('SetUp.PleaseEnterTheAddress'),
						trigger: 'blur'
					}
					// {
					// 	type: 'url',
					// 	message: '请输入正确的链接地址',
					// 	trigger: ['blur', 'change']
					// }
				]
			},
			skipUrl: false,
			phoneNumber: false,
			inputs2: '',
			props: {
				label: 'name',
				children: 'contacts'
			},
			array: [],
			options1: [],
			arr11: [],
			len: 0,
			paperjson: '',
			saveSiebleFieldLoading: false
		};
	},
	watch: {
		curWjInfo(newV) {
			console.log(newV.skipUrl);
			// this.radios2 = newV.skipUrl ? 1 : 0;
			this.skipUrl = this.radios2 == 0 ? false : true;
			this.custForm = {
				input: newV.manyThanks,
				input2: newV.skipUrl
			};
		}
	},
	mounted: function() {
		let that = this;
		var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
		this.height = winHeight - 108;
		this.rightheight = winHeight - 60;
		window.onresize = () => {
			var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
			this.height = winHeight - 108;
			this.rightheight = winHeight - 60;
		};

		that.wid = sessionStorage.getItem('wid') || 0;
		if (that.wid == 0) {
			this.wjadd();
		} else {
			sessionStorage.setItem('wid', that.wid);
			this.wjinfo();
		}
	},
	created() {},
	methods: {
		// 随机设置
		randomSet() {
			this.$refs.RandomSet.randomSetChange()
		},
		setEffectiveTime() {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.modifyValidDays}`,
				data: {
					id: that.wid,
					validDay: this.resultBody.validDay
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.$message({
							message: res.message,
							type: 'success'
						});
					} else {
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				}
			};
			that.$util.request(params);
		},
		shencaiAddsampleParameterSettingVisibleOk() {
			if (this.shencaiChfieldName == '') {
				that.$message({
					message: that.$t('SetUp.PleaseEnterAFieldName'),
					type: 'warning'
				});
				return false;
			}
			if (this.shencaiEnfieldName == '') {
				that.$message({
					message: that.$t('SetUp.PleaseEnterAnEnglishName'),
					type: 'warning'
				});
				return false;
			}
			let that = this;
			this.saveSiebleFieldLoading = true
			let params = {
				that: that,
				url: `${that.$config.service.saveSiebleFieldToFieldMapping}`,
				data: {
					chfieldName: that.shencaiChfieldName,
					enfieldName: that.shencaiEnfieldName,
					qid: that.wid,
					delTag: 0
					// isSysField:2,
					// id: id
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						// that.openAddsampleParameterSetting();
						that.openSampleParameterSetting();
						that.$message({
							message: res.message,
							type: 'success'
						});
						that.shencaiAddsampleParameterSettingVisible = false;
						that.shencaiChfieldName = '';
						that.shencaiEnfieldName = '';
					} else {
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				},
				finally() {
					that.saveSiebleFieldLoading = false
				}
			};
			that.$util.request(params);
		},
		shencaiOpenAddsampleParameterSetting() {
			this.shencaiAddsampleParameterSettingVisible = true;
		},
		synchronization() {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.synchronizationTOSiebel}?id=${that.wid}`,
				data: {
					id: that.wid
				},
				method: 'GET',
				cb(res) {
					if (res.code == 0) {
						that.$message({
							message: res.message,
							type: 'success'
						});
						that.RuleVisible = false;
						that.wjinfo();
					} else {
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				}
			};
			that.$util.request(params);
		},
		editRuleOk() {
			if (this.addRuleForm.hflx == undefined) {
				this.$message({
					message: this.$t('SetUp.SelectARuleType'),
					type: 'warning'
				});
				return false;
			}
			if (this.addRuleForm.hfqd == undefined) {
				this.$message({
					message: this.$t('SetUp.SelectARuleChannel'),
					type: 'warning'
				});
				return false;
			}
			if (this.addRuleForm.isValid == undefined) {
				this.$message({
					message: this.$t('SetUp.PleaseSelectWhetherItIsValid'),
					type: 'warning'
				});
				return false;
			}
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.modifyRule}`,
				data: {
					qid: that.wid,
					hflx: that.addRuleForm.hflx,
					hfqd: that.addRuleForm.hfqd,
					isValid: that.addRuleForm.isValid,
					id: that.addRuleForm.id
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.openRule();
						that.editRuleVisible = false;
						that.$message({
							message: res.message,
							type: 'success'
						});
						that.addRuleForm = {};
					} else {
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				}
			};
			that.$util.request(params);
		},
		editRule(value) {
			console.log(value);
			this.queryhfqdList();
			this.queryhflxList();
			this.addRuleForm = JSON.parse(JSON.stringify(value));
			this.editRuleVisible = true;
		},
		delRule(id) {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.removeRule}`,
				data: {
					qid: that.wid,
					id: id
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.openRule();
						that.$message({
							message: res.message,
							type: 'success'
						});
					} else {
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				}
			};
			that.$util.request(params);
		},
		addRuleOk() {
			if (this.addRuleForm.hflx == undefined) {
				this.$message({
					message: this.$t('SetUp.SelectARuleType'),
					type: 'warning'
				});
				return false;
			}
			if (this.addRuleForm.hfqd == undefined) {
				this.$message({
					message: this.$t('SetUp.SelectARuleChannel'),
					type: 'warning'
				});
				return false;
			}
			if (this.addRuleForm.isValid == undefined) {
				this.$message({
					message: this.$t('SetUp.PleaseSelectWhetherItIsValid'),
					type: 'warning'
				});
				return false;
			}

			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.addRule}`,
				data: {
					qid: that.wid,
					hflx: that.addRuleForm.hflx,
					hfqd: that.addRuleForm.hfqd,
					isValid: that.addRuleForm.isValid
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.openRule();
						that.addRuleVisible = false;
						that.$message({
							message: res.message,
							type: 'success'
						});
						that.addRuleForm = {};
					} else {
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				}
			};
			that.$util.request(params);
		},
		editEnumByOk() {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.modifyEnumById}`,
				data: {
					qid: that.wid,
					type: that.enumByType,
					value: that.addEnumByForm.value,
					id: that.addEnumByForm.id
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.payAReturnVisit(that.enumByType);
						that.editEnumByVisible = false;
						that.$message({
							message: res.message,
							type: 'success'
						});
						that.addEnumByForm = {};
					} else {
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				}
			};
			that.$util.request(params);
		},
		openEditEnumBy(value) {
			this.addEnumByForm = JSON.parse(JSON.stringify(value));
			this.editEnumByVisible = true;
		},
		delEnumBy(id) {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.removeEnumByIds}`,
				data: {
					qid: that.wid,
					type: that.enumByType,
					id: id
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.payAReturnVisit(that.enumByType);
						that.$message({
							message: res.message,
							type: 'success'
						});
					} else {
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				}
			};
			that.$util.request(params);
		},
		addEnumByOk() {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.addEnum}`,
				data: {
					qid: that.wid,
					type: that.enumByType,
					value: that.addEnumByForm.value
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.payAReturnVisit(that.enumByType);
						that.addEnumByVisible = false;
						that.$message({
							message: res.message,
							type: 'success'
						});
						that.addEnumByForm = {};
					} else {
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				}
			};
			that.$util.request(params);
		},
		openAddEnumBy() {
			this.addEnumByForm = {};
			this.addEnumByVisible = true;
		},
		queryhfqdList() {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.queryEnumByType}`,
				data: {
					qid: that.wid,
					type: 'hfqd',
					pageSize: 10000,
					currentPage: 1
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.hfqdList = res.resultBody.records;
					} else {
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				}
			};
			that.$util.request(params);
		},
		queryhflxList() {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.queryEnumByType}`,
				data: {
					qid: that.wid,
					type: 'hflx',
					pageSize: 10000,
					currentPage: 1
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.hflxList = res.resultBody.records;
					} else {
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				}
			};
			that.$util.request(params);
		},
		oepnAddRule() {
			this.addRuleForm = {};
			this.queryhfqdList();
			this.queryhflxList();
			this.addRuleVisible = true;
		},
		payAReturnVisit(type) {
			this.enumByType = type;
			if (type == 'hflx') {
				this.enumByTitle = this.$t('SetUp.FollowUpType');
			} else {
				this.enumByTitle = this.$t('SetUp.ReturnVisitChannels');
			}
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.queryEnumByType}`,
				data: {
					qid: that.wid,
					type: that.enumByType,
					pageSize: that.enumBypagination.pageSize,
					currentPage: that.enumBypagination.currentPage
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.enumByData = res.resultBody.records;
						that.enumBypagination.total = res.resultBody.total;
						that.enumByVisible = true;
					} else {
						that.enumByDatac = res.resultBody.records;
						that.enumBypagination.total = res.resultBody.total;
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				}
			};
			that.$util.request(params);
		},
		enumByhandleSizeChange(val) {
			this.enumBypagination.pageSize = val;
		},
		enumByhandleCurrentChange(val) {
			this.enumBypagination.currentPage = val;
		},
		RulehandleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.Rulepagination.pageSize = val;
			this.openRule();
		},
		RulehandleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.Rulepagination.currentPage = val;
			this.openRule();
		},
		openRule() {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.queryRule}`,
				data: {
					qid: that.wid,
					pageSize: that.Rulepagination.pageSize,
					currentPage: that.Rulepagination.currentPage
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.RuleData = res.resultBody.records;
						that.Rulepagination.total = res.resultBody.total;
						that.RuleVisible = true;
					} else {
						that.RuleData = res.resultBody.records;
						that.Rulepagination.total = res.resultBody.total;
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				}
			};
			that.$util.request(params);
		},
		delSampleParameterClick(id) {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.removeFieldMapping}`,
				data: {
					qid: that.wid,
					id: id
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.openSampleParameterSetting();
						that.$message({
							message: res.message,
							type: 'success'
						});
					} else {
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				}
			};
			that.$util.request(params);
		},
		addSampleParameterClick(id) {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.saveSiebleFieldToFieldMapping}`,
				data: {
					qid: that.wid,
					id: id
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.openAddsampleParameterSetting();
						that.openSampleParameterSetting();
						that.$message({
							message: res.message,
							type: 'success'
						});
					} else {
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				}
			};
			that.$util.request(params);
		},
		addhandleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.addpagination.pageSize = val;
			this.openAddsampleParameterSetting();
		},
		addhandleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.addpagination.currentPage = val;
			this.openAddsampleParameterSetting();
		},
		openAddsampleParameterSetting() {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.querySiebelFieldTable}`,
				data: {
					qid: that.wid,
					pageSize: that.addpagination.pageSize,
					currentPage: that.addpagination.currentPage
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.addSampleParameterData = res.resultBody.records;
						that.addpagination.total = res.resultBody.total;
						that.addsampleParameterSettingVisible = true;
					} else {
						that.addSampleParameterData = [];
						that.addpagination.total = 0;
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				}
			};
			that.$util.request(params);
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.pagination.pageSize = val;
			this.openSampleParameterSetting();
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.pagination.currentPage = val;
			this.openSampleParameterSetting();
		},
		openSampleParameterSetting() {
			let that = this;
			this.dataLoading = true
			let params = {
				that: that,
				url: `${that.$config.service.queryFieldMappingNotIsSys}`,
				data: {
					qid: that.wid,
					pageSize: that.pagination.pageSize,
					currentPage: that.pagination.currentPage
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.sampleParameterData = res.resultBody.records;
						that.pagination.total = res.resultBody.total;
						that.sampleParameterSettingVisible = true;
					} else {
						that.sampleParameterData = [];
						that.pagination.total = 0;
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				},
				finally() {
					that.dataLoading = false
				}
			};
			that.$util.request(params);
		},
		sibleScoringFormulaOk() {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.modifySibleScoringFormula}`,
				data: {
					id: that.wid,
					sibleScoringFormula: this.resultBody.sibleScoringFormula
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						// that.sibleScoringFormulaVisible = false;
						// that.resultBody.sibleScoringFormula = '';
						that.$message({
							message: res.message,
							type: 'success'
						});
					} else {
						that.$message({
							message: res.message,
							type: 'error'
						});
					}
				}
			};
			that.$util.request(params);
		},
		openScoringFormula() {
			this.sibleScoringFormulaVisible = true;
		},
		switchIsEnableSibleScoringFormula(value) {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.modifyIsEnableSibleScoringFormula}`,
				data: {
					id: that.wid,
					isEnableSibleScoringFormula: value
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						console.log('开关开关', value, res);
					}
				}
			};
			that.$util.request(params);
		},
		// 版权语设置开关
		copyrightSetSwitch(state) {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.setCopyrightConfig}`,
				data: {
					id: that.wid,
					copyrightConfigContent: this.resultBody.copyrightConfigContent,
					copyrightConfig: this.resultBody.copyrightConfig
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						if (state) {
							that.$message.success(res.message);
						}
					}
				}
			};
			that.$util.request(params);
		},
		switchIsEnableSible(value) {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.modifyIsEnableSible}`,
				data: {
					id: that.wid,
					isEnableSible: value
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						console.log('开关开关', value, res);
					}
				}
			};
			that.$util.request(params);
		},
		redpacket() {
			this.$emit('redpacket', 'true');
		},
		// 问卷广场开关
		setAnswerPlaza(value) {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.SetAnswerPlaza}`,
				data: {
					id: that.wid,
					ifanswerPlaza: value
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						console.log('开关开关', value, res);
					}
				}
			};
			that.$util.request(params);
		},
		limit() {
			let folding = doucment;
		},
		jumpContant() {
			this.$router.push('/contant');
		},
		clearContacts() {
			this.options1 = [];
		},
		startPsSure(value) {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.startuppassword}`,
				data: {
					id: that.wid,
					password: value
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						console.log('设置访问密码', res);
					}
				}
			};
			that.$util.request(params);
		},
		savephone() {
			let that = this;
			let smsContactsList = [];
			for (let i = 0; i < that.array.length; i++) {
				let add = {
					cellphone: that.array[i].cellphone,
					name: that.array[i].name
				};
				smsContactsList.push(add);
			}
			let params = {
				that: that,
				url: `${that.$config.service.addAnswerPhone}`,
				data: {
					id: that.wid,
					smsContactsList: smsContactsList
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.phoneNumber = false;
						console.log('设置手机号限制', res);
					}
				}
			};
			that.$util.request(params);
		},
		EmptyAll() {
			this.array = [];
		},
		queryContacts() {
			let that = this;
			let params = {
				that: that,
				url: `${that.$config.service.queryContacts}`,
				data: {},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.options1 = res.resultBody.datas;
						console.log('获取联系人列表', that.options1);
					}
				}
			};
			that.$util.request(params);
		},
		addright(data) {
			console.log('2', data);
			if (data.contacts) {
				for (let i = 0; i < data.contacts.length; i++) {
					this.arr11.push(data.contacts[i]);
				}
			} else {
				this.arr11.push(data);
			}
			this.array = this.unique(this.arr11);
			console.log('111', this.array);
			this.len = this.array.length;
		},
		unique(arr) {
			const res = new Map();
			return arr.filter(arr => !res.has(arr.id) && res.set(arr.id, 1));
		},
		setQuota() {
			let that = this;
			that.$router.replace({
				path: '/addQuota',
				query: {
					id: that.wid,
					source: 'df',
					type: '2'
				}
			});
		},
		limitPhone() {
			this.phoneNumber = true;
			this.queryContacts();
		},
		close() {
			this.hiden = false;
			this.phoneNumber = false;
		},
		customWechatSharing() {
			this.hiden = true;
		},
		jump(val) {
			this.$refs.custForm[0].validate(valid => {
				if (valid) {
					let that = this;
					let id = that.wid;
					let params = {
						that: this,
						url: `${this.$config.service.setSkip}`,
						method: 'POST',
						data: {
							skipUrl: that.custForm.input2,
							id: id,
							manyThanks: that.custForm.input
						},
						cb(res) {
							if (res.code == 0) {
								console.log('设置授权方式', res);
							}
						}
					};
					this.$util.request(params);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		Customjump(val) {
			if (val == 0) {
				this.skipUrl = false;
			} else if (val == 1) {
				this.skipUrl = true;
			}
			let that = this;
			let id = that.wid;
			let params = {
				that: this,
				url: `${this.$config.service.setCustomJump}`,
				method: 'POST',
				data: {
					id: id,
					customJump: val
				},
				cb(res) {
					if (res.code == 0) {
						console.log('设置授权方式', res);
					}
				}
			};
			this.$util.request(params);
		},
		AuthSinglechoice(val) {
			let that = this;
			let id = that.wid;
			let params = {
				that: this,
				url: `${this.$config.service.setAccreditAteMethods}`,
				method: 'POST',
				data: {
					id: id,
					grantMethod: val
				},
				cb(res) {
					if (res.code == 0) {
						console.log('设置授权方式', res);
					}
				}
			};
			this.$util.request(params);
		},
		Singlechoice(val) {
			console.log('输出', val);
			let that = this;
			let id = that.wid;
			let params = {
				that: this,
				url: `${this.$config.service.setCollectMethods}`,
				method: 'POST',
				data: {
					id: id,
					collectionMethod: val
				},
				cb(res) {
					if (res.code == 0) {
						console.log('设置收集方式', res);
					}
				}
			};
			this.$util.request(params);
		},
		kaiTimer() {
			console.log('开始时间', (this.startSelTimer = this.curWjInfo.startTime ? this.curWjInfo.startTime : ''));
			console.log('结束时间', (this.endSelTimer = this.curWjInfo.endTime ? this.curWjInfo.endTime : ''));
			// debugger
			// 比较开始时间是否小于结束时间
			if (this.startSelTimer != '' && this.endSelTimer != '') {
				if (this.endSelTimer < this.startSelTimer || this.endSelTimer == this.startSelTimer) {
					document.getElementById('timeId').style.display = 'block';
					//this.$message.error("结束时间需要大于开始时间");
					return;
				}
			}
			document.getElementById('timeId').style.display = 'none';
			let that = this;
			let id = that.wid;
			let params = {
				that: this,
				url: `${this.$config.service.updasetstartendtime}`,
				method: 'POST',
				data: {
					endTime: that.endSelTimer,
					id: id,
					startTime: that.startSelTimer
				},
				cb(res) {
					if (res.code == 0) {
						console.log('设置时间', res);
					}
				}
			};
			this.$util.request(params);
		},
		specifiedTimer() {
			if (event.target.checked == true) {
				this.specifiedTimerState = true;
			} else if (event.target.checked == false) {
				this.specifiedTimerState = false;
			}
		},
		endTimer() {
			if (event.target.checked == true) {
				this.endTimerState = true;
			} else if (event.target.checked == false) {
				this.endTimerState = false;
			}
		},
		selectSzItem(item) {
			console.log('输出设置页面item', item);
			this.curSzType = true;
		},
		loadQuestionList() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.questionlist}?id=${that.curWjInfo.id}`,
				method: 'GET',
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.paperjson = res.resultBody.tbExamPaper.paperjson;
						// console.log(that.paperjson);
						that.resultBody = res.resultBody;
						// that.resultBody.isEnableSibleScoringFormula = that.curWjInfo.isEnableSibleScoringFormula;
						that.wjId = res.resultBody.id;
						that.wxLimitFreq = res.resultBody.wxLimitFreq; // 每个微信答题次数状态
						that.wxLimitNumber = res.resultBody.wxLimitNumber; // 每个微信答题次数限制
						that.pcLimitNumber = res.resultBody.pcLimitNumber; // 每台电脑或手机答题次数限制
						that.ipLimitNumber = res.resultBody.ipLimitNumber; // 每个IP答题次数限制
						that.startPasswordNumber = res.resultBody.startUpPasswordNumber; //启动访问密码
						that.pcLimitFreq = res.resultBody.pcLimitFreq; // 每台电脑或手机答题状态
						that.ipLimitFreq = res.resultBody.ipLimitFreq; // 每个IP答题次数状态
						if (that.wxLimitFreq == 0) {
							that.wxLimitFreq = that.$t('SetUp.CanOnly')
						} else if (that.wxLimitFreq == 1) {
							that.wxLimitFreq = that.$t('SetUp.EveryHour')
						} else if (that.wxLimitFreq == 2) {
							that.wxLimitFreq = that.$t('SetUp.EveryDay')
						} else if (that.wxLimitFreq == 3) {
							that.wxLimitFreq = that.$t('SetUp.Weekly')
						} else if (that.wxLimitFreq == 4) {
							that.wxLimitFreq = that.$t('SetUp.Monthly')
						}
						if (that.pcLimitFreq == 0) {
							that.pcLimitFreq = that.$t('SetUp.CanOnly')
						} else if (that.pcLimitFreq == 1) {
							that.pcLimitFreq = that.$t('SetUp.EveryHour')
						} else if (that.pcLimitFreq == 2) {
							that.pcLimitFreq = that.$t('SetUp.EveryDay')
						} else if (that.pcLimitFreq == 3) {
							that.pcLimitFreq = that.$t('SetUp.Weekly')
						} else if (that.pcLimitFreq == 4) {
							that.pcLimitFreq = that.$t('SetUp.Monthly')
						}
						if (that.ipLimitFreq == 0) {
							that.ipLimitFreq = that.$t('SetUp.CanOnly')
						} else if (that.ipLimitFreq == 1) {
							that.ipLimitFreq = that.$t('SetUp.EveryHour')
						} else if (that.ipLimitFreq == 2) {
							that.ipLimitFreq = that.$t('SetUp.EveryDay')
						} else if (that.ipLimitFreq == 3) {
							that.ipLimitFreq = that.$t('SetUp.Weekly')
						} else if (that.ipLimitFreq == 4) {
							that.ipLimitFreq = that.$t('SetUp.Monthly')
						}
					}
				}
			};
			this.$util.request(params);
		},
		wjinfo() {
			let that = this;
			let id = that.wid;
			let params = {
				that: this,
				url: `${this.$config.service.wjinfo}?id=${id}`,
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.curWjInfo = res.resultBody;

						that.loadQuestionList();
					}
				}
			};
			this.$util.request(params);
		},
		wjadd() {
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.wjadd,
				data: {
					content: '',
					wjTitle: '问卷标题',
					wjType: '问卷类型'
				},
				cb(res) {
					if (res.code == 0) {
						that.curWjInfo = res.resultBody;
						sessionStorage.setItem('wid', that.curWjInfo.id);
						that.loadQuestionList();
					}
				}
			};
			this.$util.request(params);
		},
		switchWxLimit(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setupwxlimit}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		//每个微信答题
		wxLimit(e) {
			console.log('eeeeeeeee', e);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.updawxlimitnumber}`,
				method: 'POST',
				data: {
					id: that.wjId,
					wxLimitFreq: e,
					wxLimitNumber: that.wxLimitNumber
				},
				cb(res) {
					if (res.code == 0) {
						console.log('管边', res);
					}
				}
			};
			this.$util.request(params);
		},
		wxlimitInput() {
			let wxlimitInputFreq = this.wxLimitFreq;
			if (wxlimitInputFreq == this.$t('SetUp.CanOnly')) {
				wxlimitInputFreq = '0';
			} else if (wxlimitInputFreq == this.$t('SetUp.EveryHour')) {
				wxlimitInputFreq = '1';
			} else if (wxlimitInputFreq == this.$t('SetUp.EveryDay')) {
				wxlimitInputFreq = '2';
			} else if (wxlimitInputFreq == this.$t('SetUp.Weekly')) {
				wxlimitInputFreq = '3';
			} else if (wxlimitInputFreq == this.$t('SetUp.Monthly')) {
				wxlimitInputFreq = '4';
			}
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.updawxlimitnumber}`,
				method: 'POST',
				data: {
					id: that.wjId,
					wxLimitFreq: wxlimitInputFreq,
					wxLimitNumber: that.wxLimitNumber
				},

				cb(res) {
					if (res.code == 0) {
						console.log('微信限制次数答题几次', res);
					}
				}
			};
			this.$util.request(params);
		},
		switchPcLimit(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setupclimit}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		//每台电脑
		wxPcLimit(e) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.pclimitnumber}`,
				method: 'POST',
				data: {
					id: that.wjId,
					pcLimitFreq: e,
					pcLimitNumber: that.pcLimitNumber
				},
				cb(res) {
					if (res.code == 0) {
						console.log('管边', res);
					}
				}
			};
			this.$util.request(params);
		},
		wxPclimitInput() {
			let wxlimitInputFreq = this.pcLimitFreq;
			if (wxlimitInputFreq == this.$t('SetUp.CanOnly')) {
				wxlimitInputFreq = '0';
			} else if (wxlimitInputFreq == this.$t('SetUp.EveryHour')) {
				wxlimitInputFreq = '1';
			} else if (wxlimitInputFreq == this.$t('SetUp.EveryDay')) {
				wxlimitInputFreq = '2';
			} else if (wxlimitInputFreq == this.$t('SetUp.Weekly')) {
				wxlimitInputFreq = '3';
			} else if (wxlimitInputFreq == this.$t('SetUp.Monthly')) {
				wxlimitInputFreq = '4';
			}
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.pclimitnumber}`,
				method: 'POST',
				data: {
					id: that.wjId,
					pcLimitFreq: wxlimitInputFreq,
					pcLimitNumber: that.pcLimitNumber
				},
				cb(res) {
					if (res.code == 0) {
						console.log('管边', res);
					}
				}
			};
			this.$util.request(params);
		},
		switchpLimit(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setupiplimit}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		//问卷ip
		wxIpLimit(e) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.updaipLimitNumber}`,
				method: 'POST',
				data: {
					id: that.wjId,
					ipLimitNumber: e,
					updaipLimitNumber: that.updaipLimitNumber
				},
				cb(res) {
					if (res.code == 0) {
						console.log('ip', res);
					}
				}
			};
			this.$util.request(params);
		},
		wxIplimitInput() {
			let wxlimitInputFreq = this.ipLimitFreq;
			if (wxlimitInputFreq == this.$t('SetUp.CanOnly')) {
				wxlimitInputFreq = '0';
			} else if (wxlimitInputFreq == this.$t('SetUp.EveryHour')) {
				wxlimitInputFreq = '1';
			} else if (wxlimitInputFreq == this.$t('SetUp.EveryDay')) {
				wxlimitInputFreq = '2';
			} else if (wxlimitInputFreq == this.$t('SetUp.Weekly')) {
				wxlimitInputFreq = '3';
			} else if (wxlimitInputFreq == this.$t('SetUp.Monthly')) {
				wxlimitInputFreq = '4';
			}
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.updaipLimitNumber}`,
				method: 'POST',
				data: {
					id: that.wjId,
					ipLimitFreq: wxlimitInputFreq,
					ipLimitNumber: that.ipLimitNumber
				},
				cb(res) {
					if (res.code == 0) {
						console.log('管边', res);
					}
				}
			};
			this.$util.request(params);
		},
		switchStartUpPassword(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setupstartuppassword}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchOnlyEmail(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setuponlyemail}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchSetStartEndTime(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setupsetstartendtime}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		startTimer() {
			if (event.target.checked == true) {
				this.startTimerState = true;
			} else if (event.target.checked == false) {
				this.startTimerState = false;
			}
		},
		switchBreakpointAnswer(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setBreakpointAnswer}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchonlyWx(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setuponlywx}`,
				method: 'POST',
				data: {
					id: that.wid
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchRecordWxUser(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setuprecordwxuser}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchProhibitWXShare(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setProhibitWXShare}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchNewMsgtoWX(value) {
			console.log(value);
			if (value == 1) {
				let that = this;
				let params = {
					that: this,
					url: `${this.$config.service.setNewMsgtoWX}`,
					method: 'POST',
					data: {
						id: that.wjId
					},
					cb(res) {
						if (res.code == 0) {
							console.log(res);
							that.$message.success(res.message);
						} else {
							that.$message.error(res.message);
							that.resultBody.newMsgtoWX = 0;
						}
					}
				};
				this.$util.request(params);
			}
		},
		switchNewMsgtoEmail(value) {
			if (value == 1) {
				let that = this;
				let params = {
					that: this,
					url: `${this.$config.service.setNewMsgtoEmail}`,
					method: 'POST',
					data: {
						id: that.wjId
					},
					cb(res) {
						if (res.code == 0) {
							console.log(res);
							that.$message.success(res.message);
						} else {
							that.$message.error(res.message);
							that.resultBody.newMsgtoEmail = 0;
						}
					}
				};
				this.$util.request(params);
			}
		},
		switchIfAnswerDataLimit(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setupSetAnswerLimit}`,
				method: 'POST',
				data: {
					id: that.wjId,
					setAnswerLimit: value
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		answerLimit(limit) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.answerlimit}`,
				method: 'POST',
				data: {
					id: that.wjId,
					setAnswerLimitNumber: limit
				},
				cb(res) {
					if (res.code == 0) {
						console.log('管边', res);
					}
				}
			};
			this.$util.request(params);
		},
		switchPageAnswerTime(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setIfPageAnswerTime}`,
				method: 'POST',
				data: {
					id: that.wjId,
					setAnswerLimit: value
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		answerNumbers(num) {
			// console.log(num);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.answerTime}`,
				method: 'POST',
				data: {
					id: that.wjId,
					pageAnswerTime: num
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchIfAllowStatistics(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setIfAllowStatistics}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchIfDisplayShare(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setIfDisplayShare}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchCustomJump(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setIfCustomJump}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchShareSeoIndex(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setShareSeoIndex}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchStaging(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setModifyIsStaging}`,
				method: 'POST',
				data: {
					id: that.wjId,
					isStaging: value
				},
				cb(res) {
					if (res.code == 0) {
						// console.log(res)
					}
				}
			};
			this.$util.request(params);
		},
		switchHideLogo(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setHideLogo}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		}
	}
};
</script>

<style scoped>
.box {
}
.block {
	text-align: right;
	margin-top: 20px;
}
.answer_set_ul {
	background: #fafafa;
}

.button_line {
	margin-left: 20px;
	height: 60px;
	display: flex;
	align-items: center;
	border-bottom: 1px solid #e1e1e1;
	justify-content: space-between;
}

.limit_num {
	display: flex;
	align-items: center;
}

.limit_num_box {
	border-top: 1px solid #e1e1e1;
	border-bottom: 1px solid #e1e1e1;
	background: #f7f8fa;
	padding: 0 20px;
}

.limit_num_box .setTimer_num .timeSetting {
	padding: 0px 10px;
	display: flex;
	justify-content: space-between;
	height: 70px;
	line-height: 70px;
}
.limit_num_box .setTimer_num .timeSetting .block {
	margin-top: 0px;
}

.limit .limit_ys {
	width: 4px;
	height: 22px;
	border-left: #0080ff 4px solid;
	border-radius: 2px;
	margin-right: 7px;
	margin-left: 10px;
}

.limit > .limit_icon {
	position: absolute;
	top: 16px;
	right: 10px;
}

.limit > .limit_icon2 {
	position: absolute;
	top: 16px;
	right: 28px;
}

.limit {
	height: 50px;
	line-height: 50px;
	font-family: MicrosoftYaHei;
	font-size: 18px;
	color: #333;
	border-radius: 2px;
	background-color: #fff;
	border-bottom: 1px solid #e1e1e1;
	position: relative;
}

.limit:hover {
	color: #0080ff;
}

.wx_limit_number .wx_limit_number_dt {
	font-size: 13px;
	width: 50px;
}

.wx_limit_number {
	display: flex;
	margin-left: 20px;
	height: 52px;
	align-items: center;
}

.wx_limit_number .el-input__inner {
	width: 60px;
	height: 24px;
	border: 1px solid #ccc !important;
}

.wx_limt .el-select .el-input__inner {
	width: 100px;
	height: 24px;
	line-height: 24px;
	border: 1px solid #ccc !important;
}

.wx_limt .el-select__caret {
	height: 24px;
	line-height: 24px;
}

.el-switch {
	margin-right: 20px;
}

.el-icon-arrow-right {
	margin-right: 20px;
}

.collection_method {
	height: auto;
	display: flex;
	margin-left: 20px;
	flex-direction: column;
}
</style>
